/** @format */

import App from "fusion-react";
import Router from "fusion-plugin-react-router";
import HelmetPlugin from "fusion-plugin-react-helmet-async";
import root from "./root.js";
import fetcher from "./middleware.js";
import { captureReferralTracking } from "./shared/utils/referralTracking";
import restApis from "./admin-backend/server.js";
import {
  initSentry,
  injectHotjar,
  injectGoogleAnalytics,
} from "./shared/utils/globalScripts";

initSentry();

export default () => {
  if (typeof window !== "undefined") {
    injectHotjar();
    injectGoogleAnalytics();

    captureReferralTracking();
  }

  const app = new App(root);

  app.register(Router);
  app.register(HelmetPlugin);
  app.register(fetcher);

  if (__NODE__) {
    app.register(restApis);
  }

  return app;
};
